import { useMemo } from 'react';

import { useActiveEvacZonesQuery } from 'features/evacZones/hooks/useActiveEvacZonesQuery';
import { ManagingGeoEventsByZoneUid } from 'features/evacZones/types';
import { useAllGeoEvents } from 'features/geoEvents/hooks/useAllGeoEvents';
import { EvacZone } from 'shared/types';

export const useEvacZoneManagingGeoEvents = (
  evacZones: EvacZone[],
): ManagingGeoEventsByZoneUid => {
  const hasLockedZones = evacZones.some((evacZone) => evacZone.isLocked);
  //  These will only run queries (or use cached queries) if there are locked zones
  const activeEvacZones = useActiveEvacZonesQuery({ enabled: hasLockedZones });
  const { allGeoEvents } = useAllGeoEvents({ enabled: hasLockedZones });

  return useMemo(() => {
    const geoEventsById = new Map(
      allGeoEvents.map((geoEvent) => [geoEvent?.id, geoEvent]),
    );

    return new Map(
      activeEvacZones.flatMap(({ evacZone, geoEventId }) => {
        const geoEvent = geoEventsById.get(geoEventId);
        return geoEvent
          ? [
              [
                evacZone.uidV2,
                {
                  id: geoEvent.id,
                  name: geoEvent.name,
                  geoEventType: geoEvent.geoEventType,
                },
              ],
            ]
          : [];
      }),
    );
  }, [activeEvacZones, allGeoEvents]);
};
